import React from 'react';
import styled from 'styled-components';
import { Flex, Padding } from './base/layout-components';
import ActivityBox from './ActivityBox';
import { StyledWidgetHeader } from './base/common-styles';

const ActivityBoxContainer = styled.div`
  min-width: 15rem;
`;

const ActivitiesContainer = styled.div`
  min-height: 23rem;
  width: 100%;
`;

const ActivityOverviewContainer = ({
  activities = [],
  history,
  isFinishedOnBoarding,
  dataCyPrefix=''
}) => {
  const Activities = activities.map((activity, idx) => (
    <ActivityBoxContainer key={idx.toString()}>
      <ActivityBox
        {...activity}
        history={history}
        isFinishedOnBoarding={isFinishedOnBoarding}
        dataCyPrefix={dataCyPrefix}
      />
    </ActivityBoxContainer>
  ));
  return (
    <Padding l='medium' b='medium' t='medium' r='medium'>
      <Flex direction='column'>
        <StyledWidgetHeader style={{ paddingBottom: '4rem' }}>
          Iteration Overview
        </StyledWidgetHeader>

        <ActivitiesContainer>
          <Flex direction='row' justify='space-between'>
            {Activities}
          </Flex>
        </ActivitiesContainer>
      </Flex>
    </Padding>
  );
};

export default ActivityOverviewContainer;
